<template>
  <section class="all-cases-view" id="all-hospitals" v-loading="loading">
    <div class="navbarComponent">
      <div class="container-sm-table">
        <div class="listings-navbar">
          <el-row>
            <el-col>
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <!-- <li>
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Select Search"
                      @change="clearInputSearch"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li> -->

                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search By Name / Code / Phone / Fax"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-sm-table" style="padding-top: 0">
      <div class="primary-content-view-new">
        <div class="listings listings__table listings__all-cases">
          <el-table
            :data="hospitalsData.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              sortable="custom"
              prop="code"
              label="CODE"
              width="150"
            >
              <template #default="scope">
                <span class="emr-id cursor" @click="onView(scope.row)">
                  {{ scope.row.code }}
                </span>
              </template>
            </el-table-column>
              <el-table-column
              sortable="custom"
              prop="number"
              label="ACCOUNT NUMBER"
              width="150"
            >
              <template #default="scope">
                <span class="emr-id cursor" @click="onView(scope.row)">
                  {{ scope.row.account_number }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="name"
              label="ORDERING FACILITIES"
              min-width="250"
            >
              <template #default="scope">
                <span class="table_cell-ellipsis">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="phone"
              label="PHONE NUMBER"
              min-width="150"
            >
              <template #default="scope">
                {{ scope.row.phone || "--"}}
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="fax"
              label="FAX"
              min-width="150"
            >
              <template #default="scope">
                {{ scope.row.fax || "--"}}
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="created_at"
              label="Date Of Creation"
              min-width="150"
            >
              <template #default="scope">
                {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
              </template>
            </el-table-column>
            <el-table-column label="Status" min-width="150">
              <template #default="scope">
                <div class="column-status cursor">
                  <el-dropdown
                    class="status-dropdown"
                  >
                    <span class="el-dropdown-link">
                      <el-tag :type="getStatusType(scope.row.status)">{{
                        scope.row.status.split("_").join(" ")
                      }}</el-tag>
                    </span>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout="prev, pager, next, jumper, sizes, total"
            :total="hospitalsData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import FilterHelper from "@/mixins/FilterHelper";
import { hospitalsSearchOptions } from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "hospital",
  data() {
    return {
      searchBy: "",
      search_string: "",
      searchOptions: hospitalsSearchOptions,
      page: 1,
      pageSize: 25,
      loading: false,
      orderBy: "created_at",
      orderType: "desc",
      search_fax: "",
      search_phone: "",
      hospitalsData: {},
    };
  },
  mixins: [FilterHelper, UserPermissionsHelper],
  props: {
    selectedStatuses: {
      default: "",
    },
  },
  components: {
  },
  computed: {
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "success";
        } else if (status == "INACTIVE") {
          return "danger";
        } else {
          return "default";
        }
      };
    },
    ...mapGetters("hospitals", ["getAllHospitals", "getHospitalStatusUpdate"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
  },
  async mounted() {
    if (this.$route.query) {
      this.setQueryParamsData();
    }
    await this.fetchHospitalsList();
  },
  methods: {
    clearInputSearch() {
      if (this.search_string) {
        this.search_string = "";
        this.page = 1;
        this.fetchHospitalsList(1);
      }
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchHospitalsList();
      }, 600);
    },
    setQueryParamsData() {
      if (this.$route.query) {
        this.page = this.$route.query.selectedOrderingFacilityPage
          ? parseInt(this.$route.query.selectedOrderingFacilityPage)
          : 1;
        this.pageSize = this.$route.query.selectedOrderingFacilityPageSize
          ? parseInt(this.$route.query.selectedOrderingFacilityPageSize)
          : 25;
        if (this.$route.query.selectedOrderingFacilitySearchBy) {
          this.searchBy = this.$route.query.selectedOrderingFacilitySearchBy;
        }
        if (this.$route.query.selectedOrderingFacilityFax) {
          this.search_string = this.$route.query.selectedOrderingFacilityFax;
        }
        if (this.$route.query.selectedOrderingFacilityPhone) {
          this.search_string = this.$route.query.selectedOrderingFacilityPhone;
        }
        if (this.$route.query.selectedOrderingFacilityName) {
          this.search_string = this.$route.query.selectedOrderingFacilityName;
        }
        if (this.$route.query.selectedOrderingFacilityCode) {
          this.search_string = this.$route.query.selectedOrderingFacilityCode;
        }
        if (this.$route.query.selectedOrderingFacilitySearchString) {
          this.search_string = this.$route.query.selectedOrderingFacilitySearchString;
        }
        if (this.$route.query.selectedOrderingFacilityOrderBy) {
          this.orderBy = this.$route.query.selectedOrderingFacilityOrderBy;
        }
        if (this.$route.query.selectedOrderingFacilityOrderType) {
          this.orderType = this.$route.query.selectedOrderingFacilityOrderType;
        }
        if (this.$route.query.selectedOrderingFacility) {
          this.hospital = this.$route.query.selectedOrderingFacility;
        }
      }
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.orderBy && this.orderType) {
        params.sort_by = this.orderBy;
        params.sort_order = this.orderType;
      }
      if (this.selectedStatuses) {
        params.status = this.selectedStatuses;
      }
      if (this.searchBy && this.search_string) {
        params[this.searchBy] = this.search_string;
      } else if (this.search_string) {
        params.search_string = this.search_string;
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedOrderingFacilityPage: params.page,
        selectedOrderingFacility: params.hospital,
        selectedOrderingFacilityPageSize: params.limit,
        selectedOrderingFacilityOrderBy: params.sort_by,
        selectedOrderingFacilityOrderType: params.sort_order,
        selectedOrderingFacilityName: undefined,
        selectedOrderingFacilityFax: undefined,
        selectedOrderingFacilityCode: undefined,
        selectedOrderingFacilityPhone: undefined,
        selectedOrderingFacilitySearchString: undefined,
        selectedOrderingFacilitySearchBy: this.searchBy || undefined,
      };
      if (params.name) {
        selectedParams.selectedOrderingFacilityName = params.name;
      }
      if (params.fax) {
        selectedParams.selectedOrderingFacilityFax = params.fax;
      }
      if (params.code) {
        selectedParams.selectedOrderingFacilityCode = params.code;
      }
      if (params.phone) {
        selectedParams.selectedOrderingFacilityPhone = params.phone;
      }
      if (params.search_string) {
        selectedParams.selectedOrderingFacilitySearchString = params.search_string;
      }
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "desc";
      }
      this.fetchHospitalsList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchHospitalsList();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchHospitalsList();
    },
    async fetchHospitalsList() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("hospitals/fetchAllHospitals", params);
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  width: 10px;
  height: 10px;
}
</style>

<style lang="scss">
#all-hospitals {
  .el-dialog {
    .el-dialog__body {
      padding: 0;
    }
  }
  .container-sm-table {
    padding: 10px 0;
  }
  .primary-content-view-new {
    margin-top: 0;
  }
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-sm-table {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
}
</style>
